import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";


export class ExpensesTableCtrl implements IController {

  excludeMode: boolean;
  selectedIds: string[];
  infiniteScroll: any;
  columns: any;
  onSelectExpensesChanged: Function;
  onApproveExpense: Function;
  onDeclineExpenses: Function;
  onEditExpense: Function;
  onDeleteExpense: Function;
  onTimeLineClicked: Function;
  onDownloadClicked: Function;

  public selectedKeys: any;
  public isScrollable: boolean;

  constructor(private $mdMedia) {
  }

  $onInit() {
    this.selectedKeys = {}
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  };

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }
  }

  $doCheck() {

    this.isScrollable = !this.$mdMedia('gt-sm');
  }

  /////////////////////////////////////////////////////////////////////////////

  // ******************************
  //        External methods
  // ******************************

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  onToggleExpense(expense) {
    this.selectedKeys[expense.id] = !this.selectedKeys[expense.id];
    this.onSelectExpensesChanged({
        selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
        excludeMode: this.excludeMode
      }
    );
  }

  onToggleSelectAll() {
    this.onSelectExpensesChanged({
      selectedIds: [],
      excludeMode: !this.excludeMode
    });
  }


  // ******************************
  //        Internal methods
  // ******************************

}

angular
  .module('bringoz.admin.expenses')
  .component('expensesTable', {
    bindings: {
      infiniteScroll: '<',
      excludeMode: '<',
      selectedIds: '<?',
      columns: '<?',
      onSelectExpensesChanged: '&',
      onApproveExpense: '&',
      onDeclineExpenses: '&',
      onEditExpense: '&',
      onDeleteExpense: '&',
      onTimeLineClicked: '&',
      onDownloadClicked: '&'
    },
    template: require('./expenses-table.html').default,
    controller: ExpensesTableCtrl
  });
